export default __webpack_public_path__ + "static/media/auditorium_without_tables_rows_preview.1b9ee174.png";